import { render } from "./StepShell.vue?vue&type=template&id=405b2c92&scoped=true"
import script from "./StepShell.vue?vue&type=script&lang=ts"
export * from "./StepShell.vue?vue&type=script&lang=ts"

import "./StepShell.vue?vue&type=style&index=0&id=405b2c92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-405b2c92"

export default script